export default "__VITE_ASSET__REJcWRvq__"